import {FC} from 'react'
import {PageLink} from '../../../_metronic/layout/core'
import CompanySettings from './table/CompanySettings'
import {SettingPageTitle} from './components/header/SettingPageTitle'
import { Helmet } from 'react-helmet'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const SettingPage: FC = () => {

  return (
    <>
    <Helmet>
        <title> SecureSlate | Settings</title>
      </Helmet>
      <SettingPageTitle
        icon='Settings.svg'
        title='Settings'
        desc=' Manage your settings'
        breadcrumbs={usersBreadcrumbs}
      >
        Personnel Management
      </SettingPageTitle>
        <CompanySettings />
    </>
  )
}

export default SettingPage
